/**
 * @generated SignedSource<<8cd32b68f233ac6ba500bc1ad16d768c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type uploadFlightLogsMutation$variables = {
  deviceNodeId: string;
  flightId: string;
};
export type uploadFlightLogsMutation$data = {
  readonly requestFlightLogUpload: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly vehicle: {
      readonly flightLogsToUpload: ReadonlyArray<string | null> | null;
      readonly id: string;
    } | null;
  } | null;
};
export type uploadFlightLogsMutation = {
  response: uploadFlightLogsMutation$data;
  variables: uploadFlightLogsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceNodeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "flightId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "deviceNodeId",
        "variableName": "deviceNodeId"
      },
      {
        "kind": "Variable",
        "name": "flightId",
        "variableName": "flightId"
      }
    ],
    "concreteType": "RequestFlightLogUpload",
    "kind": "LinkedField",
    "name": "requestFlightLogUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vehicle",
        "kind": "LinkedField",
        "name": "vehicle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flightLogsToUpload",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uploadFlightLogsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uploadFlightLogsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "33bf8037be01dfc16169644ef3b38dfd",
    "id": null,
    "metadata": {},
    "name": "uploadFlightLogsMutation",
    "operationKind": "mutation",
    "text": "mutation uploadFlightLogsMutation(\n  $deviceNodeId: ID!\n  $flightId: String!\n) {\n  requestFlightLogUpload(deviceNodeId: $deviceNodeId, flightId: $flightId) {\n    errors\n    vehicle {\n      id\n      flightLogsToUpload\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1edf6d196ddc222af72c51ff72ae02b0";

export default node;
